import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { darkenHexColor, getThemeColor } from '../../../utils/styleUtils';

const getBorderRadius = shape => {
  switch (shape) {
    case 'square':
      return '0';
    case 'roundedSquare':
      return '8px'; // You can adjust the radius value as needed
    case 'circle':
    default:
      return '50%';
  }
};

export const StyledIconButton = styled(IconButton)(({
  theme,
  hasBackground,
  backgroundColor,
  hoverColor,
  width,
  height,
  color,
  shape,
}) => {
  const responsiveWidth =
    typeof width === 'object' ? theme.breakpoints.values : width;
  const responsiveHeight =
    typeof height === 'object' ? theme.breakpoints.values : height;
  const responsiveSize =
    typeof color === 'object' ? theme.breakpoints.values : color;

  return {
    ...(color && color.startsWith('#') ? { color: color } : {}),
    ...(!hasBackground
      ? {}
      : {
          backgroundColor: getThemeColor(backgroundColor, theme),
          '&:hover': {
            backgroundColor:
              hoverColor ||
              darkenHexColor(getThemeColor(backgroundColor, theme), 10),
          },
          width: responsiveWidth || 'auto',
          height: responsiveHeight || 'auto',
          borderRadius: getBorderRadius(shape),
          fontSize: responsiveSize,
        }),
    // Responsive styles for width and height
    ...(typeof width === 'object' && {
      [theme.breakpoints.up('xs')]: {
        width: width.xs || 'auto',
      },
      [theme.breakpoints.up('sm')]: {
        width: width.sm || 'auto',
      },
      [theme.breakpoints.up('md')]: {
        width: width.md || 'auto',
      },
      [theme.breakpoints.up('lg')]: {
        width: width.lg || 'auto',
      },
      [theme.breakpoints.up('xl')]: {
        width: width.xl || 'auto',
      },
    }),
    ...(typeof height === 'object' && {
      [theme.breakpoints.up('xs')]: {
        height: height.xs || 'auto',
      },
      [theme.breakpoints.up('sm')]: {
        height: height.sm || 'auto',
      },
      [theme.breakpoints.up('md')]: {
        height: height.md || 'auto',
      },
      [theme.breakpoints.up('lg')]: {
        height: height.lg || 'auto',
      },
      [theme.breakpoints.up('xl')]: {
        height: height.xl || 'auto',
      },
    }),
  };
});
